import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface DeleteComponentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  componentName: string;
  isDeleting: boolean;
}

export function DeleteComponentModal({
  isOpen,
  onClose,
  onConfirm,
  componentName,
  isDeleting,
}: DeleteComponentModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-5 w-5" />
            Delete Component
          </DialogTitle>
          <DialogDescription>This action cannot be undone.</DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <p className="text-sm text-muted-foreground mb-4">
            Are you sure you want to delete the component:
          </p>
          <div className="bg-muted/50 p-3 rounded-lg border-l-4 border-destructive">
            <p className="font-medium text-sm">"{componentName}"</p>
          </div>
          <p className="text-xs text-muted-foreground mt-3">
            This will permanently remove this form field and any associated options.
          </p>
        </div>

        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? "Deleting..." : "Delete Component"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
